import _ from "lodash"
import classNames from "classnames"
import { Column, AspectRatio, OverflowMenu, OverflowMenuItem, Grid, Row, Loading, DataTable, Table, TableContainer, TableHead, TableRow, TableHeader, TableBody, TableCell, TableToolbar, TableToolbarContent, TableToolbarSearch, TableSelectAll, TableSelectRow } from "carbon-components-react"
import "./Media.scss"
import { detectFileType } from "utils/functions"
import FileSize from "ui/FileSize/FileSize"
import { DocumentPdf20 } from "@carbon/icons-react"
import { Document20 } from "@carbon/icons-react"
import { useEffect, useState } from "react"
import { CircleFilled16 } from "@carbon/icons-react"
const MediaCard = (props) => {

    const onClickDelete = () => {
        if (window.confirm("Picture will be delete permanently. Do you want to continue?")) {
            props.onCLickDelete(props.id)
        }
    }

    const onClickAttach = () => {
        if (window.confirm("Picture will be attached to selected item. Do you want to continue?")) {
            props.onClickAttach(props.id)
        }
    }

    const onClickDetach = () => {
        if (window.confirm("Picture will be detached from selected item. Do you want to continue?")) {
            props.onClickDetach(props.id)
        }
    }

    const buttons = (props.selected) ? (
        <OverflowMenu flipped={true}>
            <OverflowMenuItem
                itemText={"Detach"}
                onClick={onClickDetach}
            />
        </OverflowMenu>
    ) : (
        <OverflowMenu flipped={true}>
            <OverflowMenuItem
                itemText={"Attach"}
                onClick={onClickAttach}
            />
            <OverflowMenuItem
                itemText={"Delete"}
                onClick={onClickDelete}
                isDelete
            />
        </OverflowMenu>
    )

    const fileMimeData = detectFileType(props.mime)

    const mediaContent = (fileMimeData.isImage) ? (
        <AspectRatio
            ratio="4x3"
            className="media-card__picture"
            style={{
                backgroundImage: `url(${props.url})`
            }}>
        </AspectRatio>
    ) : (
        <video
            className="media-card__video"
            muted
            controls>
            <source src={props.url}
                type={props.mime}></source>
            Sorry, your browser doesn't support embedded videos.
        </video>
    )

    return (
        <Column className={classNames("media-card", { "media-card__selected": props.selected })} md={3}>
            <div className="media-card__wrapper">
                {mediaContent}
                <div className="media-card__footer">
                    <div className="media-card__footer--data">
                        {props.original_filename}
                    </div>
                    {/* <div className="media-card__footer--data">
                        {fileMimeData.ext} {fileSize(props.size)}
                    </div> */}
                    <div className="media-card__footer--menu">
                        {buttons}
                    </div>
                </div>
            </div>
        </Column>

    )
}

const MediaSection = ({ attached, open, ...props }) => {

    const headerData = [
        {
            header: '',
            key: 'selectedFlag',
        },
        {
            header: '',
            key: 'icon',
        },
        {
            header: 'ID',
            key: 'id',
        },
        {
            header: 'File',
            key: 'original_filename',
        },
        {
            header: 'Type',
            key: 'mime',
        },
        {
            header: 'Size',
            key: 'size',
        },
        {
            header: '',
            key: 'buttons',
        }
    ];

    const [initialValue, setInitialValue] = useState([]);
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        if (!open) {
            setInitialValue([])
        }
    }, [open])

    useEffect(() => {
        if (attached && initialValue?.length === 0) {
            setInitialValue(initialValue => {
                return initialValue.concat(attached)
            })
        }
        setSelected(attached)
    }, [attached])

    const sortSelectedFirst = (items) => {
        let result = []
        if (attached) {
            initialValue.forEach(function (key) {
                var found = false;
                items = items.filter(function (item) {
                    if (!found && item.id === key) {
                        result.push(item);
                        found = true;
                        return false;
                    } else
                        return true;
                })

            })
        }
        result = result.concat(items)
        return result
    }

    const getFormattedRows = () => {
        let items = sortSelectedFirst(props.items)
        if (items?.length) {
            return items.map(item => {

                const fileMimeData = detectFileType(item.mime)
                const isSelected = selected?.includes(item.id)
                return {
                    ...item,
                    isSelected: isSelected,
                    selectedFlag: isSelected ? (
                        <CircleFilled16 />
                    ) : null,
                    size: <FileSize size={item.size} showFeedback />,
                    icon: fileMimeData.isImage ? (
                        <AspectRatio
                            ratio="4x3"
                            className="media-card__picture"
                            style={{
                                backgroundImage: `url(${item.url})`
                            }}>
                        </AspectRatio>
                    ) : fileMimeData.isVideo ? (
                        <video
                            className="media-card__video"
                            muted
                            controls>
                            <source src={item.url}
                                type={item.mime}></source>
                            Sorry, your browser doesn't support embedded videos.
                        </video>
                    ) : fileMimeData.isPdf ? (
                        <DocumentPdf20 />
                    ) : (
                        <Document20 />
                    ),
                    buttons: (isSelected) ? (
                        <OverflowMenu flipped={true}>
                            <OverflowMenuItem
                                itemText={"Detach"}
                                onClick={() => props.onClickDetach(item.id)}
                            />
                        </OverflowMenu>
                    ) : (
                        <OverflowMenu flipped={true}>
                            <OverflowMenuItem
                                itemText={"Attach"}
                                onClick={() => props.onClickAttach(item.id)}
                            />
                            <OverflowMenuItem
                                itemText={"Delete"}
                                onClick={() => props.onClickDelete(item.id)}
                                isDelete
                            />
                        </OverflowMenu>
                    )
                }
            })
        }
        return []
    }

    // const toggleAll = (checked) => {
    //     let newSelected = [...selected]
    //     if (!checked) {
    //         newSelected = []
    //     }
    //     else {
    //         newSelected = props.items?.map(item => item.id)
    //     }
    //     setSelected(newSelected)
    // }

    // const toggleRow = (value) => {
    //     let newSelected = [...selected]

    //     if (selected.includes(value)) {
    //         newSelected = newSelected.filter(item => item !== value)
    //     }
    //     else {
    //         newSelected.push(value)
    //     }
    //     if (newSelected.length > 0) {
    //         // Always false!!!
    //         // setShouldShowBatchActions(true)
    //     }
    //     setSelected(newSelected)

    // };

    return props.loading ? (
        <Loading />
    ) : 1 ? (
        <DataTable
            rows={getFormattedRows()}
            headers={headerData}
            stickyHeader={true}>
            {({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getSelectionProps,
                getBatchActionProps,
                onInputChange,
                selectedRows,
            }) => (
                <TableContainer>
                    <TableToolbar>
                        <TableToolbarContent>
                            <TableToolbarSearch
                                persistent
                                tabIndex={getBatchActionProps().shouldShowBatchActions ? -1 : 0}
                                onChange={onInputChange}
                            />
                        </TableToolbarContent>
                    </TableToolbar>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {/* <TableSelectAll
                                    {...getSelectionProps()}
                                    onSelect={(e) => {
                                        // console.log("TableSelectAll", getSelectionProps())
                                        // console.log("TableSelectAll", e.target.checked, e.target.indeterminate, selectedRows, e)
                                        toggleAll(e.target.checked)
                                        getSelectionProps().onSelect(e)
                                    }}
                                /> */}
                                {headers.map((header) => (
                                    <TableHeader {...getHeaderProps({ header })}>
                                        {header.header}
                                    </TableHeader>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => (
                                <TableRow {...getRowProps({ row })}>
                                    {/* <TableSelectRow
                                        {...getSelectionProps({ row })}
                                        onChange={(e) => {
                                            toggleRow(row.id)
                                            // getSelectionProps().onChange(e)
                                        }}
                                        checked={selected?.includes(row.id)}
                                    /> */}
                                    {row.cells.map((cell) => (
                                        <TableCell key={cell.id}>{cell.value}</TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </DataTable>
    ) :
        (
            <Grid className="media">
                <Row>
                    {!_.isEmpty(props.items) ? props.items.map((item, index) => {
                        return (
                            <MediaCard {...item}
                                selected={!_.isEmpty(props.attached) ? props.attached.includes(item.id) : false}
                                onCLickDelete={props.onCLickDelete}
                                onClickAttach={props.onClickAttach}
                                onClickDetach={props.onClickDetach}
                                key={`media-gallery-card-${index}`} />
                        )
                    }) : null
                    }
                </Row >
            </Grid >
        )
}

export { MediaSection }